"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkbookCustomSqlQueryWrapper = void 0;
var components_1 = require("@apollo/client/react/components");
var react_1 = __importDefault(require("react"));
var queries_1 = require("../../../gen-src/queries");
var renderQueryResult_1 = require("../renderQueryResult");
var CustomSqlDialog_1 = require("./CustomSqlDialog");
function WorkbookCustomSqlQueryWrapper(props) {
    return (react_1.default.createElement(components_1.Query, { query: queries_1.WorkbookCustomSqlDocument, variables: { vizportalUrlId: props.workbookId, selectedEmbeddedDatasourceId: props.embeddedDatasourceId } }, function (result) { return react_1.default.createElement(renderQueryResult_1.RenderQueryResult, { result: result, renderers: {
            renderData: renderCustomSqlQueries
        } }); }));
}
exports.WorkbookCustomSqlQueryWrapper = WorkbookCustomSqlQueryWrapper;
function renderCustomSqlQueries(data) {
    var workbook = data && data.workbooks ? data.workbooks[0] : null;
    var embeddedDatasource = workbook && workbook.embeddedDatasources ? workbook.embeddedDatasources[0] : null;
    if (!workbook || !embeddedDatasource) {
        return null;
    }
    var embeddedDatasourceName = embeddedDatasource.name;
    var customSqlMap = new Map();
    embeddedDatasource.fields.forEach(function (field) {
        if (field.__typename === 'ColumnField') {
            field.columns.forEach(function (column) {
                var _a;
                if (((_a = column.table) === null || _a === void 0 ? void 0 : _a.__typename) === 'CustomSQLTable') {
                    customSqlMap.set(column.table.id, column.table);
                }
            });
        }
    });
    if (customSqlMap.size === 0) {
        return null;
    }
    var customSqlTables = Array.from(customSqlMap.values());
    return (react_1.default.createElement(CustomSqlDialog_1.CustomSqlTextLink, { containsUnsupportedCustomSql: customSqlTables.some(function (t) { var _a; return (_a = t.isUnsupportedCustomSql) !== null && _a !== void 0 ? _a : false; }), customSQLTables: customSqlTables, contentType: workbook.__typename, selectedDropdownName: embeddedDatasourceName }));
}
//# sourceMappingURL=WorkbookCustomSqlQueryWrapper.js.map